export default "__VITE_ASSET__CrKRoef___"